import { useEffect } from "react"
import { HashRouter as Router, Route, Routes } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { CssBaseline } from "@mui/material"
import { createTheme, responsiveFontSizes } from "@mui/material/styles"
import { ThemeProvider } from "@mui/material/styles"
import Navigation from "./Navigation"
import LoginPage from "../login/LoginPage"
import UserNotFound from "../login/UserNotFound"
import MaintenancePage from "../maintenance/MaintenancePage"
import GTSKeyboard from "../gtsKeyboard/GTSKeyboard"
import InspectionPage from "../inspection/InspectionPage"
import AdminPage from "../admin/AdminPage"
import Footer from "../main/Footer"
import Output from "../inspection/output/InProcess"
import "../../resources/fonts/fonts.css"
import { useAuth } from "../../Functions/useAuth"
import resetHeaders from "../../Functions/ResetHeaders"
import VersionAlert from "./VersionAlert"
import UpdateGears from "../../resources/images/updateGears.png"
import axios from "../../auth/axiosAuth"
import { APPLICATION_ID, appAdminBackendURL } from "../../config"

function App() {
    const dispatch = useDispatch()
    useAuth(dispatch)

    const loggedIn = useSelector(
        (state) => state.auth.user && state.auth.user.auth
    )
    const userData = useSelector((state) => state.auth.userData)

    useEffect(() => {
        if (loggedIn) {
            resetHeaders()
        }
        return () => {}
    }, [loggedIn])

    let palette = {
        primary: { main: "#717073" },
        secondary: { main: "#DF7A00" }
    }

    if (userData) {
        palette = { ...palette, mode: userData.DarkMode }
    }

    const background = palette.mode === "dark"
    ? { default: "#303030", paper: "#424242", appBar: "#717073" }
    : { default: "#fafafa", paper: "#ffffff", appBar: "#ffffff" }

    let theme = createTheme({
        palette: {
            ...palette,
            background, 
        },
        typography: {
            fontFamily: "Century",
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: background.default, 
                        overflowX: 'hidden',
                        margin: 0,
                        padding: 0,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: background.paper,
                        backgroundImage: "none",
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: background.appBar,
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        fontSize: '14px', 
                    },
                    textarea: {
                        fontSize: '14px', 
                    },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        '&.Mui-checked': {
                            color: '#DF7A00', 
                            '& + .MuiSwitch-track': {
                                backgroundColor: '#DF7A00', 
                            },
                        },
                    },
                },
            },
        },
    });

    theme = responsiveFontSizes(theme)

    const ComponentPage = (page) => {
        return (
            <VersionAlert
                loggedIn={loggedIn}
                applicationId={APPLICATION_ID}
                axiosInstance={axios}
                updateIcon={UpdateGears}
                appAdminURL={appAdminBackendURL}
            >
                <div style={{ height: "10vh" }}>
                    <Navigation />
                </div>
                <div style={{ minHeight: "86.7vh" }}>{page}</div>
                <div style={{ height: "3vh" }}>
                    <Footer />
                </div>
            </VersionAlert>
        )
    }

    return (
        <ThemeProvider theme={responsiveFontSizes(theme)}>
            <Router>
                <CssBaseline />

                <Routes>
                    <Route path="/" exact element={<LoginPage />} />
                    <Route
                        path="/user-not-found"
                        exact
                        element={ComponentPage(<UserNotFound />)}
                    />
                    <Route
                        path="/inspection"
                        exact
                        element={ComponentPage(<InspectionPage />)}
                    />
                    <Route
                        path="/maintenance"
                        exact
                        element={ComponentPage(<MaintenancePage />)}
                    />
                    <Route
                        path="/admin"
                        exact
                        element={ComponentPage(<AdminPage />)}
                    />
                    <Route path="/gts" exact element={<GTSKeyboard />} />
                    <Route path="/output" exact element={<Output />} />
                </Routes>
            </Router>
        </ThemeProvider>
    )
}

export default App
